import { useState } from 'react';
import { IconButton, useTheme, Box } from '@mui/material';
import Notification from '../../Notification/Notification';
// icons
import { useNotification } from '../../../hooks/useNotification';
import { Bell, BellDot } from 'lucide-react';
import { useMetrics } from '@/hooks/useMetrics';
import { useConfig } from '@/hooks/useConfig';

export const NotificationSection = ({}) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const { notifications } = useNotification();
  const theme = useTheme();
  const { trackEvent } = useMetrics();
  const config = useConfig();

  const handleCloseNotification = () => {
    setAnchorEl(null);
  };

  const handleOpenNotification = (
    event: React.MouseEvent<HTMLButtonElement>,
  ) => {
    setAnchorEl(event.currentTarget);
    trackEvent({
      action: 'notification_bell_clicked',
      section: 'home',
      companies: config.slug_name ? [config.slug_name] : undefined,
    });
  };

  return (
    <Box
      sx={{
        width: 40,
        height: 40,
        borderRadius: '12px',
        backgroundColor: `${theme.palette.primary.main}10`,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
      }}
    >
      <IconButton color="primary" onClick={handleOpenNotification}>
        {Boolean(notifications.length) ? (
          <BellDot size={18} color={theme.palette.primary.main} />
        ) : (
          <Bell size={18} color={theme.palette.primary.main} />
        )}
      </IconButton>
      <Notification anchorEl={anchorEl} onClose={handleCloseNotification} />
    </Box>
  );
};
